// src/utils/style.js
export const frameClass =
  "rounded-xl border border-white/10 bg-white/5 backdrop-blur-md shadow-[inset_0_1px_4px_rgba(255,255,255,0.1),0_2px_8px_rgba(255,255,255,0.05)]";
